var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "file-upload" }, [
    _c("span", { staticClass: "input-group" }, [
      _c("span", { staticClass: "label" }, [
        _vm._v(_vm._s(_vm._f("trans")("fileupload.button")))
      ]),
      _vm._v(" "),
      _c("input", {
        ref: "input",
        attrs: {
          type: "file",
          disabled: _vm.disabled,
          multiple: _vm.multiple,
          accept: _vm.accept
        },
        on: {
          change: function($event) {
            _vm.dropped($event.target.files)
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "input form-control" }, [
        _vm.filename
          ? _c("span", [_vm._v(_vm._s(_vm.filename))])
          : _c("span", { staticClass: "muted" }, [
              _vm._v(_vm._s(_vm._f("trans")("fileupload.placeholder")))
            ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-040c256d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-040c256d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/mixins/form/File.vue
// module id = null
// module chunks = 